import {request} from "../request/request";

const schedule = {
  find: (params) => request.read('/schedule/find', params),
};

export {schedule};